import React, { useState, useContext } from "react";
import Header from '../../section/header'
import Footer from '../../section/footer'
import Icon from '@mdi/react';
import { mdiChevronRight } from '@mdi/js';
import { Link } from 'react-router-dom';
import { PageContext } from "../../App";
import PageCTA from "../../section/page-cta";

const EConsent = () => {
  const pageData = useContext(PageContext);
  const econsentData = pageData.e_consent ? JSON.parse(pageData.e_consent) : { heading: '', content: { text: '' } };
  const { heading, content } = econsentData;
  return (
    <>
    <Header/>
    <div className="content_page_wrapper">
        <div className="container">
    <ul className="page_breadcrumb">
          <li><Link to="/">Home </Link></li>
          <li><Icon path={mdiChevronRight} size={1} /> E-Consent</li>
        </ul> 
        <h1>{heading}</h1>
        <div dangerouslySetInnerHTML={{ __html: content.text }} />
        </div>
        </div>
    <PageCTA/>
    <Footer/>
      </>
  )
}

export default EConsent